/**
 * Cookie Consent Context
 */

import * as React from 'react';

import { getCookieConsentState } from './provider';
import { ICookieContext } from './types';

export const CookieContext = React.createContext<ICookieContext>({
  consentReceived: getCookieConsentState(),
  clear: () => null,
  handleConsent: () => null,
  dispatch: () => null,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/cookie/index.ts